<template>
  <div class="m_top">
    <router-link to="/">
      <img class="m_top_logo" src="../assets/logo.png" alt="">
      <div class="m_top_name" v-show="isShowHHTX">无悠网络</div>
    </router-link>

    <img class="m_top_but" src="../assets/mobile/list_but.png" alt="" @click="openMenu(true)">
    <dir class="m_top_menu" @click.self="openMenu(false)" v-show="isShowMenu">
      <div class="m_top_menu_main">
        <div v-for="item in menus" :key="item.title">
          <div class="m_top_menu_item" @click="openMenu(false)">
            <router-link :to="item.router">{{item.title}}</router-link>
          </div>
        </div>
      </div>
    </dir>
  </div>
</template>

<script>
// @ is an alias to /src
// import tools from '@/tools/tools'

export default {
  name: 'TopMobile',
  components: {
  },
  data: () => {
    return {
      isShowMenu: false,

      menus: [
        {
          title: '首页',
          router: '/'
        }, {
          title: '隐私保护',
          router: '/ys'
        }, {
          title: '用户协议',
          router: '/xy'
        }, {
          title: '客服中心',
          router: '/service'
        }, {
          title: '关于我们',
          router: '/us'
        }
      ]
    }
  },
  methods: {
    openMenu (vshow) {
      this.isShowMenu = vshow
    }
  },
  computed: {
    isShowHHTX () {
      return true// tools.isMac()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.m_top {
  position: fixed;
  height: 3rem;
  background: rgba(255, 255, 255, 0.9);
  right: 0;
  top: 0;
  left: 0;
  z-index: 99999;
}
.m_top_logo {
  position:absolute;
  left: 1.2rem;
  top: 0.5rem;
  height: 2.1rem;
}
.m_top_but {
  position:absolute;
  top: 0.2rem;
  right: 0.5rem;
  height: 1.2rem;
  padding: 0.8rem;
}
.m_top_menu {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
}
.m_top_menu_main {
  position: absolute;
  right: 0;
  top: 3rem;
  background: rgba(255, 255, 255, 0.9);
}
.m_top_menu_item {
  width: 9rem;
  height: 2.6rem;
  line-height: 2.6rem;
  margin: 0 1.2rem;
  border-bottom: 1px rgba(0,0,0,0.1) solid;
  font-size: 0.8rem;
  color: #333333;
}
.m_top_menu_item a {
  text-decoration: none;
  color: #333333;
  padding: 0.8rem 2.2rem;
}
.m_top_menu_item .router-link-exact-active {
  color: #37a1ff;
}
.m_top_name {
  position: absolute;
  left: 6rem;
  top: 1rem;
  font-weight: bold;
  color: rgba(0,0,0,0.3);
  font-size: 0.8rem;
}
</style>
